// SPDX-License-Identifier: LicenseRef-Proprietary
import React from 'react';
import './Auth.css';

// Environment detection
const isDev =
  process.env.REACT_APP_ENVIRONMENT?.toLowerCase() === 'dev' ||
  process.env.NODE_ENV === 'development';

const LOGIN_PATH =
  process.env.REACT_APP_LOGIN_PATH ||
  (isDev ? '/auth/login' : '/api/auth/login');

interface PendingApprovalPageProps {
  onReturnHome?: () => void;
}

export const PendingApprovalPage: React.FC<PendingApprovalPageProps> = ({
  onReturnHome = () => {
    // Clear the pending state and redirect to home
    sessionStorage.removeItem('account_pending');
    window.location.href = '/';
  }
}) => {
  const handleLogin = () => {
    // Clear the pending state before redirecting to login
    sessionStorage.removeItem('account_pending');
    window.location.assign(LOGIN_PATH);
  };
  return (
    <div className="pending-approval-page">
      <div className="pending-approval-content">
        <div className="pending-approval-icon">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h1 className="pending-approval-title">Account Pending Approval</h1>
        <p className="pending-approval-message">
          Your registration was successful!
        </p>
        <p className="pending-approval-submessage">
          Please contact an administrator to enable your account before you can log in.
          Once your account has been approved, you will be able to access the application.
        </p>
        <button
          className="pending-approval-button"
          onClick={onReturnHome}
        >
          Return to Home
        </button>
        <div className="pending-approval-login-link">
          <span>Already approved? </span>
          <button
            className="pending-approval-login"
            onClick={handleLogin}
            type="button"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalPage;
